import { createFileRoute } from '@tanstack/react-router'
import FormTemplateVariables from '../components/form-template-variables/FormTemplateVariables'

export const Route = createFileRoute('/_a/templateVariables/')({
  component: FormTemplateVariables,
})
